module.exports = __webpack_public_path__ + "img/finel-screening.1ff8b6cc.svg";